/**
 * Formats a duration in seconds into a human-readable label.
 * Shared between FullscreenCountdownTakeover and BlankScreen countdown.
 */
export function formatDurationLabel(
  totalSeconds: number,
  formatStyle: "short" | "medium" | "long" | "digital",
): string {
  const safeSeconds = Math.max(0, totalSeconds);
  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);
  const secs = safeSeconds % 60;

  if (formatStyle === "digital") {
    if (hours > 0) {
      return [hours, minutes, secs]
        .map((part) => part.toString().padStart(2, "0"))
        .join(":");
    }
    return [minutes, secs]
      .map((part) => part.toString().padStart(2, "0"))
      .join(":");
  }

  if (formatStyle === "short") {
    if (hours > 0) return `${hours}h ${minutes}m ${secs}s`;
    if (minutes > 0) return `${minutes}m ${secs}s`;
    return `${secs}s`;
  }

  if (formatStyle === "medium") {
    if (hours > 0) return `${hours} hr ${minutes} min ${secs} sec`;
    if (minutes > 0) return `${minutes} min ${secs} sec`;
    return `${secs} sec`;
  }

  // long (default)
  if (hours > 0) {
    return `${hours} hour${hours === 1 ? "" : "s"}, ${minutes} minute${minutes === 1 ? "" : "s"} and ${secs} second${secs === 1 ? "" : "s"}`;
  }
  if (minutes > 0) {
    return `${minutes} minute${minutes === 1 ? "" : "s"} and ${secs} second${secs === 1 ? "" : "s"}`;
  }
  return `${secs} second${secs === 1 ? "" : "s"}`;
}
